/* Drawer arrow → pagination delegation
   Ensures Swiper arrows inside #ShopNowContainer behave like pagination dots,
   even when the drawer is injected after initial page load. */
(function () {
  if (window._shopNowArrowDelegated) return; // guard against double-injection
  window._shopNowArrowDelegated = true;

  document.addEventListener('click', function (event) {
    // respond only to clicks on prev/next arrows inside the drawer
    const arrow = event.target.closest('#ShopNowContainer .swiper-button-prev, #ShopNowContainer .swiper-button-next');
    if (!arrow) return;

    // find the slider container that owns the pagination element
    const container = arrow.closest('.swiper, .product-medias');
    if (!container) return;

    const pagination = container.querySelector('.swiper-pagination');
    if (!pagination) return;

    const bullets = Array.from(pagination.querySelectorAll('.swiper-pagination-bullet'));
    if (!bullets.length) return;

    const active = pagination.querySelector('.swiper-pagination-bullet-active') || bullets[0];
    let idx = bullets.indexOf(active);
    idx += arrow.classList.contains('swiper-button-next') ? 1 : -1;
    idx = (idx + bullets.length) % bullets.length;

    bullets[idx].click();
    event.preventDefault();
  });
})();
